// Session-local "already shown" set, shared by the two popups.
//
// Cleared when the tab closes, so notices re-appear on a fresh app open but
// never twice within one session. Login notices are written here as soon as
// they are queued: the same notice can legitimately exist in both channels
// (see the is_login PUT caveat in the API doc), and without this the user
// would dismiss the sign-in modal only to meet it again on Home.
const SESSION_KEY = 'hg.notif-popup-seen';

export function getSeenIds(): Set<string> {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

export function markSeen(...ids: string[]) {
  try {
    const seen = getSeenIds();
    for (const id of ids) seen.add(id);
    sessionStorage.setItem(SESSION_KEY, JSON.stringify([...seen]));
  } catch { /* storage unavailable */ }
}
